import { IPluDataQuery } from 'generated/rbi-graphql';
import { ServiceMode } from 'state/service-mode/types';
import { isDelivery } from 'utils/service-mode';

export default function getRestaurantPlusData(
  restaurantPlus: IPluDataQuery | undefined,
  serviceMode: ServiceMode | null
) {
  return isDelivery(serviceMode) && restaurantPlus?.pluData?.deliveryPlus
    ? restaurantPlus?.pluData.deliveryPlus
    : restaurantPlus?.pluData?.plus;
}
